// extracted by mini-css-extract-plugin
export default {"cls1":"RatingCard-cls1__qB","cls2":"RatingCard-cls2_IXT RatingCard-cls1__qB"};